import type { WelcomeMissionKind } from './welcomeMission.consts';
import type { UserQuestDto } from '@/queries/userQuest/userQuest.schema';

const WELCOME_COMPLETED_STATE_VISIBLE_MS = 24 * 60 * 60 * 1000;

function normalizeMissionName(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export function getWelcomeMissionKind(mission: UserQuestDto): WelcomeMissionKind | null {
  const normalizedCandidates = [
    mission.quest.name,
    mission.quest.questTemplateId,
    mission.questId,
  ].map(normalizeMissionName);

  if (normalizedCandidates.some(value => value.includes('get-the-app') || value.includes('app-install'))) {
    return 'get-the-app';
  }

  if (normalizedCandidates.some(value => value.includes('get-offers') || value.includes('adw-email') || value.includes('marketing-email'))) {
    return 'get-offers';
  }

  if (normalizedCandidates.some(value => value.includes('enable-push') || value.includes('push-notification'))) {
    return 'enable-push';
  }

  return null;
}

export function isMissionCompleted(mission: UserQuestDto) {
  return !!mission.completedAt;
}

export function shouldShowWelcomeCompletedState(missions: UserQuestDto[], now = Date.now()) {
  if (!missions.length || missions.some(mission => !isMissionCompleted(mission))) {
    return false;
  }

  const completedTimestamps = missions
    .map(mission => Date.parse(mission.completedAt!))
    .filter(Number.isFinite);

  if (!completedTimestamps.length) {
    return false;
  }

  const lastCompletedAt = Math.max(...completedTimestamps);
  return now - lastCompletedAt < WELCOME_COMPLETED_STATE_VISIBLE_MS;
}

export function shouldHideCompletedWelcomeMissions(missions: UserQuestDto[], now = Date.now()) {
  if (!missions.length || missions.some(mission => !isMissionCompleted(mission))) {
    return false;
  }

  return !shouldShowWelcomeCompletedState(missions, now);
}
